module.exports = __webpack_public_path__ + "static/media/shadows-of-olympus.fe8a7291.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GameIcon/shadows-of-olympus.png
// module id = 1363
// module chunks = 1